<div class="policyWidget paymentWidget paymentCompleteWidget">
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image--blue wrapClose__logo" alt="Coverpath"></div>
        <button type="button" class="close" (click)="cancel()">Close</button>
      </div>
    </div>
  </div>
  <div class="wrap wrapHead">
    <div class="pageHead">
      <h1>Job well done</h1>
      <div class="subhead">Your bank account has been successfully updated.</div>
    </div>
  </div>
  <div class="wrap wrapMain"></div>
  <div class="wrap wrapFoot">
    <div class="cta">
      <button type="button" class="btnReturn" (click)="cancel()">Return to my policy</button>
    </div>
  </div>
</div>
